import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { contractDownloadName } from '@app/features/contracts/contract-file-name';
import { ContractService } from '@app/features/contracts/contract-service';
import { DownloadService } from '@app/features/download.service';
import { switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-direct-download',
  imports: [CommonModule, MatProgressSpinner],
  templateUrl: './direct-download.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./direct-download.scss'],
})
export class DirectDownload implements OnInit {
  readonly cdr = inject(ChangeDetectorRef);
  readonly contractService = inject(ContractService);
  readonly downloadService = inject(DownloadService);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  contractId: string | null = null;
  employeeFullName: string | null = null;

  ngOnInit(): void {
    this.contractId = this.route.snapshot.paramMap.get('contractId');
    this.contractService
      .findOne(this.contractId!)
      .pipe(
        switchMap((contract) => {
          this.employeeFullName = `${contract.employee.firstname} ${contract.employee.lastname}`;
          this.cdr.detectChanges();
          return this.contractService.getPdf(this.contractId!).pipe(
            tap((blob) => {
              // Le contrat se télécharge sous le nom du disque réseau du pôle social
              // (RG-contrat-nom-de-telechargement).
              this.downloadService.downloadFile(
                `${contractDownloadName(contract.contract)}.pdf`,
                blob,
                'application/pdf',
              );
            }),
          );
        }),
      )
      .subscribe({
        next: () => this.router.navigate(['/contrats']),
        error: (err) =>
          console.error('Direct download failed for contract ID:', this.contractId, err),
      });
  }
}
